
import { defineComponent } from "vue";

export default defineComponent({
   name: "SvgIcon",
   props: {
      name: {
         type: String,
         required: true,
         default: "project-collapse",
      },
      size: {
         type: Number,
         default: 32,
      },
      color: {
         type: String,
         default: "#000",
      },
   },
   setup(props) {
      return {
         props,
      };
   },
});
